/**
 * Auth Module
 */
import Vue from 'vue'
import axios from 'axios'
import Nprogress from 'nprogress';
import router from '../../../router';
import myHttpApi from '../../../api/myHttpApi';

const state = {
    user: localStorage.getItem('user'),
    token: localStorage.getItem('usertoken') || '',
    status: ''
}

// getters
const getters = {
    getUser: state => {
        return state.user;
    },
    isAuthenticated: state => !!state.token,
    authStatus: state => state.status,
}

// actions
const actions = {
   
    signinUserInPosworld(context, payload) {
        Vue.$isSupport = false;

        const { user } = payload;
        axios.post(Vue.$urlAPI + 'BOLogin', user)
                .then(resp => {
               
                Vue.$isSupport = false;
                const token = resp.data.Token;
                Vue.$tokenAPI = token;
                //console.log ("token: "+  Vue.$tokenAPI);
                localStorage.setItem('usertoken', token) // store the token in localstorage
                localStorage.setItem('username', resp.data.UserName);

                if (token == null)
                {
                    localStorage.removeItem('usertoken'); // if the request fails, remove any possible user token if possible
                    var e = new Error('Ongeldige login'); 
                    context.commit('loginUserFailure', e);
                }
                else
                {

                    Vue.$StoreMenu = resp.data.Menus;
                    Vue.$startupPath = resp.data.StartupPath;
                   

                    Nprogress.done();
                    setTimeout(() => {
                        context.commit('loginUserSuccess', user, token);
                    }, 500)
                }

               

                })
            .catch(err => {
                Vue.$tokenAPI = "";
                localStorage.removeItem('usertoken') // if the request fails, remove any possible user token if possible
                context.commit('loginUserFailure', err);
            })
    },
    logoutUserFromPosworld(context) {
        Nprogress.start();
        context.commit('logoutUser');
    }
}

// mutations
const mutations = {
    loginUser(state) {
        Nprogress.start();
        state.status = 'loading'
    },
    loginUserSuccess(state, user, token) {
        state.user = user;
        localStorage.setItem('user',JSON.stringify(user));
        
        state.status = 'success'
        state.token = token

        if (Vue.$startupPath != "")
        {
            router.push(Vue.$startupPath);
        }
        else
        {
            router.push("/default/dashboard");
        }

        setTimeout(function(){
            Vue.notify({
                group: 'loggedIn',
                type: 'success',
                text: 'User Logged In Success!'
            });
       },1500);
    },
    loginUserFailure(state, error) {
        Nprogress.done();
        state.status = 'error'
        
        Vue.notify({
            group: 'loggedIn',
            type: 'error',
            text: error.message
        });
    },
    logoutUser(state) {
        state.user = null
        state.status = 'logout'
        localStorage.removeItem('usertoken')
        localStorage.removeItem('user');
        router.push("/session/login");
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
